import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FEEDBACK_STATUS_OPTIONS } from './FeedbackBadges';

const selectSx = {
  height: '40px',
  borderRadius: '8px',
  fontSize: '0.875rem',
  minWidth: 170,
  backgroundColor: '#fff',
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E0E0E0' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#BDBDBD' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
};

/**
 * FeedbackFilters - Barra de filtros da aba "Feedbacks" (Admin Geral)
 * @param {Object} props
 * @param {string} props.searchInput
 * @param {Function} props.onSearchChange
 * @param {string} props.type
 * @param {Function} props.onTypeChange
 * @param {string} props.status
 * @param {Function} props.onStatusChange
 */
function FeedbackFilters({ searchInput, onSearchChange, type, onTypeChange, status, onStatusChange }) {
  const isMobile = useMediaQuery('(max-width: 760px)');

  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        flexWrap: isMobile ? 'wrap' : 'nowrap',
        borderBottom: '1px solid #E8ECF0',
        bgcolor: '#fff',
      }}
    >
      <TextField
        size="small"
        placeholder="Buscar por título, descrição, usuário ou empresa"
        value={searchInput}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'text.disabled', fontSize: 18 }} />
            </InputAdornment>
          ),
        }}
        sx={{
          flex: 1,
          minWidth: 220,
          maxWidth: { sm: 420 },
          '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            backgroundColor: '#fff',
            height: '40px',
            '& fieldset': { borderColor: '#E0E0E0' },
            '&:hover fieldset': { borderColor: '#BDBDBD' },
            '&.Mui-focused fieldset': { borderColor: 'primary.main' },
          },
          '& input': { fontSize: '0.875rem' },
        }}
      />

      <Select size="small" value={type} onChange={(e) => onTypeChange(e.target.value)} sx={selectSx}>
        <MenuItem value="">Todos os tipos</MenuItem>
        <MenuItem value="problem">Problema</MenuItem>
        <MenuItem value="improvement">Melhoria</MenuItem>
      </Select>

      <Select size="small" value={status} onChange={(e) => onStatusChange(e.target.value)} sx={selectSx}>
        <MenuItem value="">Todos os status</MenuItem>
        {FEEDBACK_STATUS_OPTIONS.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
        ))}
      </Select>
    </Box>
  );
}

export default FeedbackFilters;
